import React from "react";
import { AuthProvider } from './contexts/AuthContext';
import { TenantProvider } from './contexts/TenantContext';
import Routes from "./Routes";

function App() {
  return (
    <TenantProvider>
      <AuthProvider>
        <Routes />
      </AuthProvider>
    </TenantProvider>
  );
}

export default App;